module.exports = __webpack_public_path__ + "static/media/tiktok_icon.cc23ae5f.svg";